<script setup lang="ts">
import { landing } from '@/routes';
import { Link } from '@inertiajs/vue3';

interface Props {
    presentation?: 'form' | 'landing';
}
withDefaults(defineProps<Props>(), { presentation: 'form' });
</script>

<template>
    <div class="bg-canvas text-ink min-h-screen font-sans antialiased">
        <slot name="header">
            <header
                class="border-border bg-surface/80 fixed top-0 right-0 left-0 z-50 border-b backdrop-blur-lg"
            >
                <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div class="flex h-16 items-center">
                        <Link :href="landing()" class="flex items-center">
                            <span
                                class="font-display text-ink text-2xl font-semibold tracking-tight"
                                >Finzzo</span
                            >
                        </Link>
                    </div>
                </div>
            </header>
        </slot>

        <main
            id="main-content"
            tabindex="-1"
            :class="
                presentation === 'form'
                    ? 'flex min-h-screen items-center justify-center px-4 pt-16 sm:px-6 lg:px-8'
                    : 'outline-none'
            "
        >
            <slot />
        </main>

        <slot name="footer" />
    </div>
</template>
